import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CSSProperties } from 'react';

export const ContentWrapper = styled(Stack)(() => ({
  alignItems: 'flex-end',
  backgroundColor: 'var(--color-grey-lighter)',
  borderRadius: 'var(--border-radius-small)',
  padding: 'var(--spacing-medium)',
}));

export const WrapperRootStyles: CSSProperties = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
};
